export default __webpack_public_path__ + "static/media/back_arrow_red.2def6652.svg";